function extensionOf(name = '') {
  const index = String(name).lastIndexOf('.');
  return index >= 0 ? String(name).slice(index + 1).toLowerCase() : '';
}

function parseTabularContent(content) {
  const text = String(content || '').trim();
  if (!text) return { Sheet1: [] };
  try {
    const parsed = JSON.parse(text);
    if (Array.isArray(parsed)) return { Sheet1: parsed };
    if (parsed && typeof parsed === 'object') {
      if (parsed.sheets && typeof parsed.sheets === 'object') return parsed.sheets;
      return parsed;
    }
  } catch (_) {
    // Fall through to CSV/TSV parsing.
  }
  const delimiter = text.includes('\t') ? '\t' : ',';
  return {
    Sheet1: text.split(/\r?\n/).map(line => line.split(delimiter).map(cell => cell.trim()))
  };
}

function markdownToPlainBlocks(markdown) {
  return String(markdown || '')
    .replace(/```[\w-]*\n?/g, '')
    .replace(/```/g, '')
    .split(/\r?\n/)
    .map(line => line.replace(/^#{1,6}\s+/, '').replace(/^[-*+]\s+/, '• ').replace(/\*\*([^*]+)\*\*/g, '$1'));
}

export async function generateWorkspaceBlob(filename, mime, content) {
  const extension = extensionOf(filename);
  if (extension === 'csv') {
    const sheets = parseTabularContent(content);
    const rows = sheets.Sheet1 || Object.values(sheets)[0] || [];
    const csv = rows.map(row => (Array.isArray(row) ? row : [row]).map(cell => {
      const value = String(cell == null ? '' : cell);
      return /[",\r\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
    }).join(',')).join('\r\n');
    return new Blob([csv], { type: mime || 'text/csv;charset=utf-8' });
  }

  if (extension === 'xlsx') {
    const XLSX = await import(/* webpackChunkName: "workspace-xlsx" */ 'xlsx');
    const workbook = XLSX.utils.book_new();
    const sheets = parseTabularContent(content);
    Object.entries(sheets).forEach(([name, rows]) => {
      const safeRows = Array.isArray(rows) ? rows : [];
      XLSX.utils.book_append_sheet(workbook, XLSX.utils.aoa_to_sheet(safeRows), String(name).slice(0, 31) || 'Sheet');
    });
    const data = XLSX.write(workbook, { type: 'array', bookType: 'xlsx' });
    return new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  }

  if (extension === 'docx') {
    const docx = await import(/* webpackChunkName: "workspace-docx-generator" */ 'docx');
    const paragraphs = markdownToPlainBlocks(content).map(line => new docx.Paragraph({
      children: [new docx.TextRun(line)]
    }));
    const documentFile = new docx.Document({ sections: [{ children: paragraphs }] });
    return docx.Packer.toBlob(documentFile);
  }

  return new Blob([String(content || '')], { type: mime || 'text/plain;charset=utf-8' });
}
